import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {TreeComponent} from '../../../components/v2/tree/tree.component';
import {ClaimService} from '@service/crm/claim.service';
import {MatDialog} from '@angular/material/dialog';
import {ClaimDetailComponent} from '../claim-detail/claim-detail.component';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-claims',
    templateUrl: './claims.component.html',
    styleUrls: ['claims.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ClaimsComponent implements OnInit, OnDestroy {
  searchForm: UntypedFormGroup;
  @ViewChild(TreeComponent) tree: TreeComponent | undefined;
  stateSelection: { name: string; value: string | number; }[] = [];
  claims: any;
  actions = [{
    icon: 'fa-eye',
    func: (id: number) => {
      this.router.navigate(['crm', 'claim', id]);
    }
  }];
  private destroy$ = new Subject<void>();

  constructor(
    private fb: UntypedFormBuilder,
    private claimService: ClaimService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.searchForm = this.fb.group({
      customer: [],
      orderName: [],
      state: [],
      commRef: [],
    });

  }

  ngOnInit(): void {
    this.updateData();
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  doSearch(): void {
    const data = this.searchForm.getRawValue();
    this.tree?.applyFilter(data);
  }

  clearFilter(): void {
    this.tree?.clearFilter();
    this.searchForm.reset();
  }

  private updateData(): void {
    this.claimService.getClaims()
      .pipe(takeUntil(this.destroy$))
      .subscribe((claims) => {
        this.claims = claims;
        this.prepareAllFilters(this.claims);
        this.cdr.detectChanges();
      });
  }

  prepareAllFilters<T extends {[key: string]: any}>(from: T[]): void {
    this.stateSelection = this.prepareSelection('stateLabel', from);
  }

  prepareSelection<T extends {[key: string]: string}>(key: keyof T, from: T[]): { name: string; value: string; disabled?: boolean | undefined; }[] {
    return [...new Set([''].concat(from?.map((x) => x[key])))].sort().map((z) => ({
      name: z,
      value: z
    }));
  }

  public openClaimWithId(id: number): void {
    const template = this.dialog.open(ClaimDetailComponent, {
      width: '90%',
      height: '90%',
      panelClass: 'p-0',
      disableClose: true
    });
    template.componentInstance.claimId = id;
    template.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data.modified) {
          this.updateData();
        }
        this.router.navigate(['crm', 'claims']);
      });
  }

}
